


















































































import Vue from 'vue';
import {
  HubCard,
  HubFileInput,
  HubIcon,
  HubLoading,
  HubSelect,
  HubSlider,
  HubSwitch,
} from '@/components/HubComponents';
import { image as ApiImage } from '../../services/apiImage/index';
import CustomError from '../../config/CustomError';

interface WatermarkProps {
  show: number;
  positionSelected: string;
  opacity: number;
  imageSource: string;
  uploadingImageLoader: boolean;
}

export default Vue.extend({
  name: 'WatermarkContainer',

  components: {
    HubCard,
    HubFileInput,
    HubIcon,
    HubLoading,
    HubSelect,
    HubSlider,
    HubSwitch,
  },

  props: {
    value: {
      type: Object as () => WatermarkProps,
      default: {
        show: 0,
        positionSelected: '',
        opacity: 50,
        imageSource: '/uploads/2021-05-28/wbifeaBKJENRzeFnYQSoasoF.png',
        uploadingImageLoader: false,
      },
      required: true,
    },
  },

  data() {
    return {
      watermarkFile: undefined,
      watermarkOptions: [
        { text: this.$t('top_right'), value: 'top_right' },
        { text: this.$t('top_left'), value: 'top_left' },
        { text: this.$t('bottom_right'), value: 'bottom_right' },
        { text: this.$t('bottom_left'), value: 'bottom_left' },
      ],
    };
  },

  watch: {
    value: {
      handler(newValue) { return this.$emit('input', newValue); },
      deep: true,
    },
    async watermarkFile(): Promise<void> {
      this.value.uploadingImageLoader = true;
      const file = (this as any).watermarkFile;

      try {
        if (!file) {
          throw new CustomError('No file selected!');
        }

        const size = (file as File).size / 1024 / 1024;

        if (size > 1) {
          this.$store.dispatch('notification/create', {
            text: this.$t('File size exceeds the limit of 1MB. Please upload a smaller image.'),
            type: 'error',
          }, { root: true });
          throw new CustomError('File is too big. File needs to be less than 1 MB');
        }

        const userInfo = localStorage.getItem('user');
        let odPlanId = '';
        if (userInfo) {
          const customerObjectId = JSON.parse(userInfo);
          odPlanId = customerObjectId.user.od_plan_id;
        }
        const body = new FormData();
        body.set('file', file);
        body.set('noflow', '1');
        body.set('APP', `OD-${odPlanId}`);
        body.set('type', 'WATERMARK');

        await ApiImage(body)
          .then((res) => {
            const { source } = res.data;
            this.value.imageSource = source;
          })
          .finally(() => {
            this.value.uploadingImageLoader = false;
            // teste local
            // setTimeout(() => { this.value.uploadingImageLoader = false; }, 5000);
          });
      } catch (error) {
        this.value.uploadingImageLoader = false;

        if (error instanceof CustomError) {
          console.error('[CustomError] => ', error.getMessage());
          return;
        }

        console.error('[Error] => ', error);
      }
    },
  },
});
